import API from '@/helpers/api';

export async function find(params = {}) {
  return API('/expenses', params).fetch();
}

export async function findById(id) {
  return API(`/expenses/${id}`).fetch();
}
